import { router, useGlobalSearchParams } from 'expo-router';

import { ServiceModeSelectDialog as SelectDialog } from './service-mode-dialog';

export function openServiceModeDialog() {
  router.setParams({
    serviceModeDialog: 'open',
  });
}

export function closeServiceModeDialog() {
  router.setParams({
    serviceModeDialog: 'closed',
  });
}

export function ServiceModeDialog() {
  const params = useGlobalSearchParams();
  const isOpen = params.serviceModeDialog === 'open';

  return <SelectDialog isOpen={isOpen} onClose={closeServiceModeDialog} />;
}
